import { PrimaryButton } from "components/Button/style";
import {
  Container,
  ContainerHeader,
  FormContainer,
  IconeTooltipServico,
  InputContainer,
  OptionContainer,
  RadioContainer,
  Title,
} from "./style";
import { FaPlus } from "react-icons/fa";
import { IFiltrosListarSolicitacoesLicenciamento } from "../../Interfaces/IFiltrosListarSolicitacoesLicenciamento";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { Col, Form, Row } from "react-bootstrap";
import { Required } from "components/Required";
import { UF_OPTIONS } from "../../Constants";
import { CustomInput } from "components/CustomInput";
import { IDadosEmitirLicenciamento } from "../../Interfaces/IDadosEmitirLicenciamento";
import { ModalCertezaCancelarLote } from "../ModalCertezaCancelarLote";
import { useState } from "react";
import { IProcessoCriarLoteLicenciamentos } from "../../Interfaces/IProcessoCriarLoteLicenciamentos";

interface Props {
  empresasOptions: IOptions[];
  setDadosEmitir: (dados: IDadosEmitirLicenciamento) => void;
  dadosEmitir: IDadosEmitirLicenciamento;
  onClickEscolherProcessos: () => void;
  processos: IProcessoCriarLoteLicenciamentos[];
  onClickSalvarLote: () => void;
}

const anoAtual = new Date().getFullYear();

const opcoesAno = [
  { label: String(anoAtual), value: anoAtual },
  { label: String(anoAtual - 1), value: anoAtual - 1 },
];

export function DadosLoteLicenciamento({
  empresasOptions,
  setDadosEmitir,
  dadosEmitir,
  onClickEscolherProcessos,
  processos,
  onClickSalvarLote,
}: Readonly<Props>) {
  const [showModalCertezaCancelarLote, setShowModalCertezaCancelarLote] =
    useState<boolean>(false);
  return (
    <Container>
      <ContainerHeader>
        <Title>Criar novo lote de licenciamentos</Title>
        <div style={{ display: "flex", gap: 8 }}>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            onClick={() => setShowModalCertezaCancelarLote(true)}
            outline
            variante="primary"
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            onClick={onClickEscolherProcessos}
            outline
            variante="primary"
          >
            <FaPlus /> Adicionar processo
          </PrimaryButton>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            onClick={onClickSalvarLote}
            disabled={
              !dadosEmitir.exercicio ||
              !dadosEmitir.idEmpresa ||
              !dadosEmitir.uf ||
              !processos ||
              !processos.length
            }
          >
            Salvar lote
          </PrimaryButton>
        </div>
      </ContainerHeader>
      <hr />
      <FormContainer>
        <Row style={{ height: 90 }}>
          <Col md={2}>
            <Form.Group>
              <Form.Label>
                UF <Required />
              </Form.Label>
              <DropdownSelect
                options={UF_OPTIONS}
                selectedValue={dadosEmitir.uf}
                onSelect={(e) => setDadosEmitir({ ...dadosEmitir, uf: e })}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>
                Exercício <Required />
                <IconeTooltipServico title="UF de emplacamento" />
              </Form.Label>
              <DropdownSelect
                options={opcoesAno}
                selectedValue={dadosEmitir.exercicio}
                onSelect={(e) =>
                  setDadosEmitir({ ...dadosEmitir, exercicio: e })
                }
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Descrição</Form.Label>
              <CustomInput
                type="text"
                placeholder="Informe a descrição"
                value={dadosEmitir.descricao}
                onChange={(e) =>
                  setDadosEmitir({ ...dadosEmitir, descricao: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>
        <Row style={{ height: 80 }}>
          <Col>
            <Form.Group>
              <Form.Label>
                Empresa <Required />
              </Form.Label>
              <DropdownSelect
                options={empresasOptions}
                selectedValue={dadosEmitir.idEmpresa}
                onSelect={(e) =>
                  setDadosEmitir({ ...dadosEmitir, idEmpresa: e })
                }
                searchable
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Gerar recibo de cobrança</Form.Label>
            </Form.Group>
            <RadioContainer>
              <OptionContainer
                onClick={() =>
                  setDadosEmitir({ ...dadosEmitir, cobrar: "SIM" })
                }
              >
                <input
                  id="radioCobrarSim"
                  type="radio"
                  className="custom-radio"
                  value="SIM"
                  checked={dadosEmitir.cobrar === "SIM"}
                  style={{ marginRight: 8 }}
                />
                <label htmlFor="radioCobrarSim">Sim</label>
              </OptionContainer>

              <OptionContainer
                onClick={() =>
                  setDadosEmitir({ ...dadosEmitir, cobrar: "NAO" })
                }
              >
                <input
                  id="radioCobrarNao"
                  type="radio"
                  className="custom-radio"
                  value="NAO"
                  checked={dadosEmitir.cobrar === "NAO"}
                  style={{ marginRight: 8 }}
                />
                <label htmlFor="radioCobrarNao">Não</label>
              </OptionContainer>
            </RadioContainer>
          </Col>
        </Row>
      </FormContainer>
      <ModalCertezaCancelarLote
        show={showModalCertezaCancelarLote}
        handleClose={() => setShowModalCertezaCancelarLote(false)}
      />
    </Container>
  );
}
